// font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircleNotch,
  faSpinner,
  faEye,
  faEyeSlash,
  faUserCircle,
  faLock,
  faTachometerAlt,
  faEnvelope,
  faPhoneAlt,
  faSearchLocation,
  faAddressCard,
  faHouseUser,
  faChartLine,
  faUser,
  faUserPlus,
  faSignOutAlt,
  faCog,
  faEllipsisH,
  faMeteor,
  faThLarge,
  faFileInvoice,
  faBolt,
  faStopwatch,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faCalendar,
  faChargingStation,
  faHeart,
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faPlus,
  faMinus,
  faUsers,
  faMousePointer,
  faExclamation,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCircleNotch,
  faSpinner,
  faEye,
  faEyeSlash,
  faUserCircle,
  faLock,
  faTachometerAlt,
  faEnvelope,
  faPhoneAlt,
  faSearchLocation,
  faAddressCard,
  faHouseUser,
  faChartLine,
  faUser,
  faUserPlus,
  faSignOutAlt,
  faCog,
  faEllipsisH,
  faMeteor,
  faThLarge,
  faFileInvoice,
  faBolt,
  faStopwatch,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faCalendar,
  faChargingStation,
  faHeart,
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faPlus,
  faMinus,
  faUsers,
  faMousePointer,
  faExclamation
);
